import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from "@stripe/react-stripe-js";
import InputField from "components/Input";
import Disclaimer from "../Disclaimer";
import "./index.scss";

const cardNumberElementOptions = {
  showIcon: true,
  style: {
    base: {
      fontSize: "16px",
      backgroundColor: "#fff",
      color: "#292b33",
      "::placeholder": {
        color: "#8a8e99",
        fontWeight: "300",
      },
    },
  },
  placeholder: "---- ---- ---- ----",
};

const cardElementOptions = {
  style: {
    base: {
      fontSize: "16px",
      backgroundColor: "#fff",
      color: "#292b33",
      "::placeholder": {
        color: "#8a8e99",
        fontWeight: "300",
      },
    },
  },
};

const CardDetails = ({
  cardErrorMessage,
  validateInput,
  validateCardOnchange,
  cardDetails,
  handleChangeCardName,
}) => {
  const [hideCvc, setHideCvc] = useState(false);

  return (
    <form className="card-wrapper">
      <h2>Card Details</h2>
      <div className="input-field">
        {cardErrorMessage?.cardNumber && (
          <p className="label -error">{cardErrorMessage?.cardNumber}</p>
        )}
        <div
          className={`custom-field ${
            cardErrorMessage?.cardNumber ? "-error" : ""
          }`}
        >
          <CardNumberElement
            id="cardNumber"
            options={cardNumberElementOptions}
            onChange={validateCardOnchange}
          />
        </div>
        <label htmlFor="cardNumber" className="label">
          Card Number
        </label>
      </div>
      <InputField
        id="name"
        placeholder="Cardholder Name"
        label="Cardholder Name"
        value={cardDetails?.name}
        onChange={(e) => handleChangeCardName(e)}
        onBlur={(e) => validateInput(e)}
        error={cardErrorMessage?.name}
      />
      <div className="form-group">
        <div className="input-field">
          {cardErrorMessage?.cardExpiry && (
            <label className="label -error">
              {cardErrorMessage?.cardExpiry}
            </label>
          )}
          <div
            className={`custom-field ${
              cardErrorMessage?.cardExpiry ? "-error" : ""
            }`}
          >
            <CardExpiryElement
              id="cardExpiry"
              options={cardElementOptions}
              onChange={validateCardOnchange}
            />
          </div>
          <label htmlFor="cardExpiry" className="label">
            Card Expiry
          </label>
        </div>
        <div className="input-field">
          {cardErrorMessage?.cardCvc && (
            <label className="label -error">{cardErrorMessage?.cardCvc}</label>
          )}
          <div
            className={`custom-field ${
              cardErrorMessage?.cardCvc ? "-error" : ""
            } ${hideCvc ? "no-placeholder" : ""}`}
            id="cvc"
          >
            <CardCvcElement
              id="cardCvc"
              options={cardElementOptions}
              onChange={validateCardOnchange}
              placeholder=""
              maxLength={5}
            />
            <span
              className={hideCvc ? "icon-eye-close" : "icon-eye"}
              onClick={() => setHideCvc(!hideCvc)}
              aria-hidden
            />
          </div>
          <label htmlFor="cardCvc" className="label">
            CVC/CVV
          </label>
        </div>
      </div>
      <Disclaimer />
    </form>
  );
};

CardDetails.defaultProps = {
  payments: {},
  cardErrorMessage: "",
  cardDetails: {},
  handleChangeCardName: () => {},
  validateCardOnchange: () => {},
  validateInput: () => {},
};

CardDetails.propTypes = {
  payments: PropTypes.shape({
    map: PropTypes.func.isRequired,
  }),
  cardErrorMessage: PropTypes.string,
  cardDetails: PropTypes.object,
  handleChangeCardName: PropTypes.func,
  validateCardOnchange: PropTypes.func,
  validateInput: PropTypes.func,
};

export default CardDetails;
